(() => {
  'use strict';

  const lockBody = (locked) => document.body.classList.toggle('is-locked', locked);
  const parseDocument = (html) => new DOMParser().parseFromString(html, 'text/html');
  const formatMoney = (cents) => {
    const currency = window.Orvasco?.currency || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency }).format(cents / 100); }
    catch { return `${(cents / 100).toFixed(2)} ${currency}`; }
  };

  /* Galeriyi secilen varyant icin SUNUCUDAN yeniden alir.

     Onceki surum yalnizca DOM'daki figurleri gizliyordu. Ama sunucu zaten sadece
     acilistaki varyantin medyasini basiyor — baska bir rengi secince gosterecek
     figur yok, dolayisiyla galeri oldugu gibi kaliyordu (olculdu: Black secilince
     ekranda 16 Gold gorseli kaliyordu).

     Bolum Sunum API'si ile ayni Liquid yeniden calisiyor: dogru acilis gorseli,
     dogru karolar, dogru sayac. Suzme mantigi tek yerde — Liquid'de — kaliyor. */
  let galleryRequest = null;
  const swapGalleryForVariant = async (variant, productRoot) => {
    const gal = document.querySelector('[data-pdp-gallery]');
    const handle = productRoot.dataset.productHandle;
    const sectionId = productRoot.dataset.sectionId;
    if (!gal || !variant || !handle || !sectionId) return;

    galleryRequest?.abort();
    const request = new AbortController();
    galleryRequest = request;
    gal.setAttribute('aria-busy', 'true');

    try {
      const root = window.Shopify?.routes?.root || '/';
      const url = `${root}products/${handle}?section_id=${encodeURIComponent(sectionId)}&variant=${variant.id}`;
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) throw new Error(`gallery ${response.status}`);
      const fresh = parseDocument(await response.text()).querySelector('[data-pdp-gallery]');
      if (!fresh) throw new Error('gallery missing');

      gal.innerHTML = fresh.innerHTML;
      gal.dataset.variantKey = fresh.dataset.variantKey || '';
      /* Reveal gozlemcisi yalnizca acilista .reveal ariyor; sonradan gelen
         dugumler gizli kalirdi. Zaten ekrandalar, dogrudan aciyoruz. */
      gal.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-in'));
      gal.scrollLeft = 0;
      window.Orvasco?.refreshGallery?.();
    } catch (error) {
      // Ag hatasi: galeri oldugu gibi kalir, sayfa calisir durumda.
      if (error.name !== 'AbortError') gal.dataset.galleryError = '1';
    } finally {
      if (galleryRequest === request) {
        galleryRequest = null;
        gal.removeAttribute('aria-busy');
      }
    }
  };

  document.querySelectorAll('[data-product-root]').forEach((productRoot) => {
    const variantData = productRoot.querySelector('[data-variants-json]');
    if (!variantData) return;
    const variants = JSON.parse(variantData.textContent);
    const optionGroups = [...productRoot.querySelectorAll('[data-product-option]')];
    // Option groups are radio fieldsets now, but a <select> still reads correctly
    // through the same helper, so older section renders keep working.
    const valueOf = (group) => {
      if (group.tagName === 'SELECT' || group.tagName === 'INPUT') return group.value;
      return group.querySelector('input[type="radio"]:checked')?.value ?? '';
    };
    const idInputs = productRoot.querySelectorAll('input[name="id"]');
    const price = productRoot.querySelector('[data-current-price]');
    const compare = productRoot.querySelector('[data-compare-price]');
    const addButtons = productRoot.querySelectorAll('[data-add-button]');
    const modelButton = productRoot.querySelector('[data-view-model]');
    const stock = productRoot.querySelector('[data-stock]');
    const stockLabel = productRoot.querySelector('[data-stock-label]');
    const lowStock = productRoot.querySelector('[data-stock-low]');
    const lowStockLabel = productRoot.querySelector('[data-stock-low-label]');
    const lowStockOn = productRoot.dataset.lowStock === 'true';
    const lowStockThreshold = Number(productRoot.dataset.lowStockThreshold || 6);

    const updateVariant = (fromInteraction) => {
      const selected = optionGroups.map(valueOf);
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!variant) return;
      idInputs.forEach((input) => { input.value = variant.id; });

      optionGroups.forEach((group) => {
        const chosen = group.querySelector('input[type="radio"]:checked');
        const readout = group.querySelector('[data-option-selected]');
        if (chosen && readout) readout.textContent = chosen.value;
      });

      if (stock && stockLabel) {
        stock.classList.toggle('is-out', !variant.available);
        stockLabel.textContent = variant.available
          ? (stock.dataset.inStockLabel || stockLabel.textContent)
          : (stock.dataset.soldOutLabel || stockLabel.textContent);
      }

      if (lowStock && lowStockLabel) {
        // Shopify only reports a meaningful count when it manages the variant's
        // inventory; anything else stays hidden rather than guessing a number.
        const tracked = lowStockOn
          && variant.inventory_managed === 'shopify'
          && variant.available
          && Number.isFinite(variant.inventory_quantity)
          && variant.inventory_quantity > 0
          && variant.inventory_quantity <= lowStockThreshold;
        lowStock.hidden = !tracked;
        if (tracked) {
          lowStockLabel.textContent = (productRoot.dataset.lowStockLabel || '{{ count }} left')
            .replace('{{ count }}', variant.inventory_quantity)
            .replace('{{count}}', variant.inventory_quantity);
        }
      }
      if (price) price.textContent = formatMoney(variant.price);
      if (compare) {
        compare.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
        compare.hidden = !(variant.compare_at_price > variant.price);
      }
      addButtons.forEach((button) => {
        button.disabled = !variant.available;
        button.textContent = variant.available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
      });
      if (modelButton) modelButton.dataset.activeModel = variant.model_media_id || modelButton.dataset.defaultModel;
      // Acilista sunucu zaten dogru medyayi basti; yalnizca secim degisince yenile.
      if (fromInteraction) swapGalleryForVariant(variant, productRoot);
      // Only rewrite the URL once the shopper has actually chosen something, so a
      // shared link keeps whatever variant it arrived with.
      if (!fromInteraction) return;
      // Varyant secimi: hangi secenegin denendigi, alinmayan urunlerde en degerli sinyal.
      window.Orvasco?.publishEvent?.('orvasco:variant_selected', {
        variant_id: variant.id,
        variant_title: variant.title,
        available: variant.available,
        product_handle: window.location.pathname.split('/products/')[1]?.split('?')[0] || ''
      });
      const variantUrl = new URL(window.location.href);
      variantUrl.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', `${variantUrl.pathname}${variantUrl.search}${variantUrl.hash}`);
    };

    optionGroups.forEach((group) => group.addEventListener('change', () => updateVariant(true)));
    updateVariant(false);
  });

  /* ---- sticky buy bar -------------------------------------------------------
     Revealed once the real buy box has scrolled out of view, so the two are never
     on screen competing with each other. */
  (() => {
    const bar = document.querySelector('[data-sticky-atc]');
    const anchor = document.querySelector('.pdp__buy .product-form__actions, .pdp__buy .pdp__form');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.hidden = false;
      bar.classList.toggle('is-visible', show);
      // Footer paneli ekranin altina yapisiyor; cubuk goruntudeyken paneli
      // onun ustunde tutmak icin yuksekligini tek bir degiskenden yayinliyoruz.
      document.documentElement.style.setProperty(
        '--mq-sticky-atc-h',
        show ? `${Math.round(bar.getBoundingClientRect().height) + 12}px` : '0px'
      );
    }, { threshold: 0 });
    observer.observe(anchor);
  })();

  /* ---- gallery overlap ------------------------------------------------------
     Referanstaki hareket: acilis gorseli yiginin tepesinde durur, alttaki ikili
     izgara kaydirmayla onun yarisi kadar yukari kayip uzerine biner, sonra durur.
     Olculen referans degerleri: translateY heroH -> heroH/2 arasinda, orada
     sabitleniyor.

     Sinif JS'ten ekleniyor: script calismazsa galeri duz yigın olarak kalir. */
  (() => {
    const gal = document.querySelector('[data-pdp-gallery]');
    if (!gal) return;
    /* Galeri icerigi varyant degisiminde bastan yaziliyor, bu yuzden acilis
       gorseli her seferinde yeniden aranmali: bir kez yakalanan referans
       degisimden sonra DOM'da olmayan bir dugumu tutuyor. */
    const heroOf = () => gal.querySelector('.pdp__hero');
    if (!heroOf() || !gal.querySelector('.pdp__pair')) return;

    const wide = window.matchMedia('(min-width: 990px)');
    const still = window.matchMedia('(prefers-reduced-motion: reduce)');
    let half = 0;
    let queued = false;

    const measure = () => {
      const hero = heroOf();
      if (!hero) return;
      half = Math.round(hero.getBoundingClientRect().height / 2);
      gal.style.setProperty('--pdp-hero-half', `${half}px`);
    };

    const update = () => {
      queued = false;
      if (!gal.classList.contains('pdp__gal--overlap')) return;
      // Galerinin ust kenari ekranin ustune ciktikca izgara yukari kayar.
      const travelled = Math.min(Math.max(-gal.getBoundingClientRect().top, 0), half);
      gal.style.setProperty('--pdp-shift', `${half - travelled}px`);
    };

    const onScroll = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };

    const apply = () => {
      const on = wide.matches && !still.matches;
      if (on) {
        measure();
        gal.classList.add('pdp__gal--overlap');
        update();
        window.addEventListener('scroll', onScroll, { passive: true });
      } else {
        gal.classList.remove('pdp__gal--overlap');
        gal.style.removeProperty('--pdp-shift');
        gal.style.removeProperty('--pdp-hero-half');
        window.removeEventListener('scroll', onScroll);
      }
    };

    /* Mobil serit sayaci. Serit yerlesik kaydirma ile calisiyor; burada yalnizca
       hangi slaytta oldugumuzu yaziyoruz. */
    const counter = gal.parentElement?.querySelector('[data-pdp-slide]');
    if (counter) {
      let countQueued = false;
      const syncCount = () => {
        countQueued = false;
        const w = gal.clientWidth;
        if (!w) return;
        counter.textContent = String(Math.round(gal.scrollLeft / w) + 1);
      };
      gal.addEventListener('scroll', () => {
        if (countQueued) return;
        countQueued = true;
        requestAnimationFrame(syncCount);
      }, { passive: true });
    }

    // Acilis gorselinin yuksekligi ancak yuklendiginde kesinlesir.
    let heroObserver = null;
    const bindHero = () => {
      const hero = heroOf();
      if (!hero) return;
      const heroImg = hero.querySelector('img');
      if (heroImg && !heroImg.complete) heroImg.addEventListener('load', () => { measure(); update(); }, { once: true });
      if ('ResizeObserver' in window) {
        heroObserver?.disconnect();
        heroObserver = new ResizeObserver(() => { measure(); update(); });
        heroObserver.observe(hero);
      }
    };

    wide.addEventListener('change', apply);
    still.addEventListener('change', apply);

    /* Varyant degisimi galeriyi bastan yaziyor; olcumler ve gozlemci yeni acilis
       gorseline yeniden baglanmali. Dinleyiciler gal ve window uzerinde, ikisi de
       yerinde kaliyor — bu yuzden burada yalnizca yeniden olcuyoruz. */
    window.Orvasco = window.Orvasco || {};
    window.Orvasco.refreshGallery = () => { bindHero(); apply(); };

    bindHero();
    apply();
  })();

  /* ---- specification panel --------------------------------------------------
     The panel is a <details>, so it works without JavaScript. This only adds the
     close button, Escape, and a click outside. */
  (() => {
    const disclosure = document.querySelector('[data-specs-panel]');
    if (!disclosure) return;
    const close = () => { disclosure.open = false; };

    const panel = disclosure.querySelector('.specs-panel');

    // Uses the theme's single body lock so the panel and the drawers never fight
    // over the pinned scroll offset.
    const lock = (on) => window.Orvasco?.lockBody?.(on);

    disclosure.addEventListener('toggle', () => {
      lock(disclosure.open);
      if (disclosure.open) {
        if (panel) panel.scrollTop = 0;
        disclosure.querySelector('[data-specs-close]')?.focus();
      }
    });

    disclosure.querySelector('[data-specs-close]')?.addEventListener('click', close);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && disclosure.open) close();
    });
    document.addEventListener('click', (event) => {
      if (!disclosure.open) return;
      // The summary row is inside the disclosure, so only clicks outside the panel close it.
      if (event.target.closest('.specs-panel') || event.target.closest('.specs-disclosure > summary')) return;
      close();
    });
  })();

  // Shopify's model-viewer package and product GLB load only after explicit intent.
  const modelDialog = document.querySelector('[data-model-dialog]');
  const modelStage = modelDialog?.querySelector('[data-model-stage]');
  let modelFeaturesLoaded = false;
  const loadModelFeatures = () => new Promise((resolve) => {
    if (modelFeaturesLoaded || !window.Shopify?.loadFeatures) { resolve(); return; }
    window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: () => { modelFeaturesLoaded = true; resolve(); } }]);
  });

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-view-model]');
    if (!trigger || trigger.disabled || !modelDialog || !modelStage) return;
    const modelId = trigger.dataset.activeModel || trigger.dataset.defaultModel;
    const sourceTemplate = document.querySelector(`[data-model-template="${CSS.escape(modelId)}"]`);
    if (!sourceTemplate) return;
    modelDialog.showModal();
    window.Orvasco?.publishEvent?.('orvasco:3d_opened', { product_handle: trigger.dataset.productHandle || '', model_media_id: modelId });
    lockBody(true);
    modelStage.classList.remove('is-ready');
    await loadModelFeatures();
    modelStage.querySelector('model-viewer, .shopify-model-viewer-ui')?.remove();
    modelStage.append(sourceTemplate.content.cloneNode(true));
    const viewer = modelStage.querySelector('model-viewer');
    if (viewer) {
      viewer.setAttribute('camera-controls', '');
      viewer.setAttribute('auto-rotate', '');
      viewer.setAttribute('shadow-intensity', '1.2');
      viewer.setAttribute('environment-image', 'neutral');
      const scale = Number(modelStage.dataset.scale || 1);
      const rotation = Number(modelStage.dataset.rotation || 0);
      viewer.setAttribute('scale', `${scale} ${scale} ${scale}`);
      viewer.setAttribute('orientation', `0deg ${rotation}deg 0deg`);
      viewer.addEventListener('load', () => modelStage.classList.add('is-ready'), { once: true });
    } else modelStage.classList.add('is-ready');
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-model-close]')) return;
    modelDialog?.close();
    lockBody(false);
  });
  modelDialog?.addEventListener('close', () => lockBody(false));

  const recentKey = 'orvasco-recent-v1';
  try {
    const legacyRecent = localStorage.getItem('metaquartz-recent-v1');
    if (!localStorage.getItem(recentKey) && legacyRecent) localStorage.setItem(recentKey, legacyRecent);
    localStorage.removeItem('metaquartz-recent-v1');
  } catch { /* Storage may be unavailable. */ }
  const validRecentItem = (item) => item && typeof item === 'object' && typeof item.handle === 'string' && typeof item.url === 'string' && typeof item.title === 'string';
  document.querySelectorAll('[data-current-product]').forEach((node) => {
    try {
      const current = JSON.parse(node.textContent);
      if (!validRecentItem(current)) return;
      const stored = JSON.parse(localStorage.getItem(recentKey) || '[]');
      const items = (Array.isArray(stored) ? stored : []).filter(validRecentItem).filter((item) => item.handle !== current.handle);
      items.unshift(current);
      localStorage.setItem(recentKey, JSON.stringify(items.slice(0, 8)));
    } catch {}
  });

  document.querySelectorAll('[data-recently-viewed]').forEach((container) => {
    let items = [];
    try { const stored = JSON.parse(localStorage.getItem(recentKey) || '[]'); items = Array.isArray(stored) ? stored : []; } catch {}
    items = items.filter(validRecentItem).filter((item) => item.handle !== container.dataset.currentHandle).slice(0, 4);
    if (!items.length) return;
    const grid = document.createElement('div');
    grid.className = 'product-grid';
    items.forEach((item) => {
      const article = document.createElement('article');
      article.className = 'product-card';
      const link = document.createElement('a');
      link.className = 'product-card__media';
      link.href = item.url;
      if (typeof item.image === 'string' && item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        image.width = 640;
        image.height = 800;
        link.append(image);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'product-card__placeholder';
        placeholder.textContent = window.Orvasco?.strings?.imagePending || '';
        link.append(placeholder);
      }
      const copy = document.createElement('div');
      copy.className = 'product-card__content';
      const title = document.createElement('h3');
      title.className = 'product-card__title';
      title.textContent = item.title;
      const priceNode = document.createElement('p');
      priceNode.className = 'product-card__price';
      priceNode.textContent = item.price;
      copy.append(title, priceNode);
      article.append(link, copy);
      grid.append(article);
    });
    container.append(grid);
  });

  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    if (!section.dataset.url) return;
    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) return;
      const documentFragment = parseDocument(await response.text());
      const replacement = documentFragment.querySelector('[data-product-recommendations]');
      if (replacement) section.replaceWith(replacement);
    } catch {}
  });
})();
